<template>
  <div>
    <v-dialog v-if="persistent" v-model="snackbarVisible" :persistent="true" width="450" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <div v-html="$t('cookies.banner_title')"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" class="mx-1" text @click="openCookieSettings()">{{ $t('cookies.settings') }}</v-btn>
          <v-btn color="primary" class="mx-1" @click="acceptAllCookies()" data-testid="cookie-banner-allow-all">{{ $t('cookies.allow_all') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-else outlined elevation="4" v-model="snackbarVisible" :timeout="-1" vertical right>
      <div v-html="$t('cookies.banner_title')"></div>
      <template v-slot:action="{ attrs }">
        <v-btn color="secondary" class="mx-1" text v-bind="attrs" @click="openCookieSettings()">{{ $t('cookies.settings') }}</v-btn>
        <v-btn color="secondary" class="mx-1" @click="rejectAllCookies()">{{ $t('cookies.reject_all') }}</v-btn>
        <v-btn color="secondary" class="mx-1" @click="acceptAllCookies()" data-testid="cookie-banner-allow-all">{{ $t('cookies.allow_all') }}</v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="settingsVisible" width="450" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable :persistent="persistent">
      <cookie-settings @updated="settingsUpdated()"/>
    </v-dialog>
  </div>
</template>

<script>
import cookieconsent from '@/js/cookieconsent'
import CookieSettings from './CookieSettings.vue'

export default {
  name: "CookieBanner",
  components: {
    CookieSettings
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      snackbarVisible: this.show && !cookieconsent.hasAcceptedCookies(),
      settingsVisible: false,
    }
  },
  methods: {
    openCookieSettings() {
      this.snackbarVisible = false;
      this.settingsVisible = true;
    },
    rejectAllCookies() {
      cookieconsent.rejectAllCookies();
      this.snackbarVisible = false;
      this.settingsVisible = false;
      this.$emit("updated");
    },
    acceptAllCookies() {
      cookieconsent.acceptAllCookies();
      this.snackbarVisible = false;
      this.settingsVisible = false;
      this.$emit("updated");
    },
    settingsUpdated() {
      this.settingsVisible = false;
      this.$emit("updated");
    }
  },
  mounted() {
    cookieconsent.parseConsentTransferParameter(this.$route.query);
    cookieconsent.parseOnetrustConsent();

    if (cookieconsent.hasAcceptedCookies() || !this.show) {
      this.snackbarVisible = false;
      this.settingsVisible = false;
    }
    else {
      this.snackbarVisible = true;
      this.settingsVisible = false;
    }
  },
  watch: {
    settingsVisible(new_visible, old_visible) {
      if (!new_visible && old_visible) {
        if (!cookieconsent.hasAcceptedCookies()) {
          this.snackbarVisible = true;
        }
      }
    },
    show(new_show, old_show) {
      if (new_show && !old_show) {
        this.snackbarVisible = true;
        this.settingsVisible = false;
      }
      else if (!new_show && old_show) {
        this.snackbarVisible = false;
        this.settingsVisible = false;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cookies/CookieBanner.vue